/**
 * The file types the media gallery takes, and the media type each one counts as - the media type decides which size
 * limit applies. Everything not listed here is refused, which is what keeps executables and scripts out.
 * The browser and the backend read the same map, so the two can never disagree about what is allowed.
 */
export const MEDIA_KIND_BY_EXTENSION = {
  '.bmp': { mediaType: 'image', mimeType: 'image/bmp' },
  '.gif': { mediaType: 'image', mimeType: 'image/gif' },
  '.jpeg': { mediaType: 'image', mimeType: 'image/jpeg' },
  '.jpg': { mediaType: 'image', mimeType: 'image/jpeg' },
  '.png': { mediaType: 'image', mimeType: 'image/png' },
  '.webp': { mediaType: 'image', mimeType: 'image/webp' },

  '.m4v': { mediaType: 'video', mimeType: 'video/x-m4v' },
  '.mov': { mediaType: 'video', mimeType: 'video/quicktime' },
  '.mp4': { mediaType: 'video', mimeType: 'video/mp4' },
  '.webm': { mediaType: 'video', mimeType: 'video/webm' },

  '.doc': { mediaType: 'document', mimeType: 'application/msword' },
  '.docx': { mediaType: 'document', mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
  '.pdf': { mediaType: 'document', mimeType: 'application/pdf' },
  '.ppt': { mediaType: 'document', mimeType: 'application/vnd.ms-powerpoint' },
  '.pptx': { mediaType: 'document', mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' },
  '.txt': { mediaType: 'document', mimeType: 'text/plain' },
  '.xls': { mediaType: 'document', mimeType: 'application/vnd.ms-excel' },
  '.xlsx': { mediaType: 'document', mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
}

// The file-type icon a media type falls back to wherever it has no preview of its own
export const MEDIA_TYPE_ICONS = {
  document: 'fa-file-alt',
  image: 'fa-file-image',
  video: 'fa-file-video',
}

// What the file picker offers. Extensions rather than mime types, phones do not agree on the mime type of a recording
export const MEDIA_GALLERY_ACCEPT = Object.keys(MEDIA_KIND_BY_EXTENSION).join(',')

// A contributor shares what they recorded on the day. Documents belong to the organisation and are added from inside
export const CONTRIBUTED_MEDIA_TYPES = ['image', 'video']

export const MEDIA_CONTRIBUTION_ACCEPT = Object.entries(MEDIA_KIND_BY_EXTENSION)
  .filter(([, kind]) => CONTRIBUTED_MEDIA_TYPES.includes(kind.mediaType))
  .map(([extension]) => extension)
  .join(',')

export function mediaKindForFileName (fileName) {
  let dotIndex = fileName.lastIndexOf('.')
  if (dotIndex < 0) {
    return null
  }
  return MEDIA_KIND_BY_EXTENSION[fileName.slice(dotIndex).toLowerCase()] ?? null
}

// The documents that are recognisable on sight get their own icon rather than the plain document one
const DOCUMENT_ICONS_BY_EXTENSION = {
  '.doc': 'fa-file-word',
  '.docx': 'fa-file-word',
  '.pdf': 'fa-file-pdf',
  '.ppt': 'fa-file-powerpoint',
  '.pptx': 'fa-file-powerpoint',
  '.xls': 'fa-file-excel',
  '.xlsx': 'fa-file-excel',
}

export function mediaItemIcon (item) {
  const fileName = item.originalName ?? ''
  const extension = fileName.slice(fileName.lastIndexOf('.')).toLowerCase()
  return DOCUMENT_ICONS_BY_EXTENSION[extension] ?? MEDIA_TYPE_ICONS[item.mediaType] ?? 'fa-file'
}
